import React from "react"
import './footer.css';

function Footer() {
  return(
    <footer>
      <div className="footer-content">
        <div></div>
        <div>
          <h2>Imprint</h2>
          <p>
            Tobias Kheir-Buchmann<br />
            Förrådsvägen 40<br />
            141 46 Huddinge,
            Sweden
            </p>
        </div>
        <div>
          <h2>Contact</h2>
          <p>
            <a href="https://twitter.com/tobi_or_not" target="blank">Twitter</a> &nbsp;
            <a href="http://se.linkedin.com/in/tobiasbuchmann/" target="blank">LinkedIn</a>
            <br/>
            <a href="https://github.com/tobi-or-not" target="blank">Github</a> &nbsp;
            <a href="mailto:letterbox@tobi-or-not.de">Email</a>
          </p>
        </div>
        <div></div>
      </div>
    </footer>
  )
}


export default Footer;
